/**
 * The buffers one world buffer keeps for one screen-space pass, built again whenever the shape the
 * pass asks for differs from the shape they were built at.
 */
import { sameData } from '../../utils/sameData.js';
export class FittedBuffers {
    build;
    leave;
    buffers = null;
    /**
     * `build` makes the buffers at a shape. `leave` takes a slot off them before they go, as binding
     * a deleted texture is an error.
     */
    constructor(build, leave = () => { }) {
        this.build = build;
        this.leave = leave;
    }
    /** The buffers of the last fit, or null before the first. */
    get current() {
        return this.buffers;
    }
    /** The buffers at `shape`: the current ones where they were built at it, else new ones. */
    fit(renderer, shape) {
        if (this.buffers && sameData(this.buffers.shape, shape))
            return this.buffers;
        this.release(renderer);
        this.buffers = this.build(renderer, shape);
        return this.buffers;
    }
    release(renderer) {
        if (!this.buffers)
            return;
        this.leave(renderer, this.buffers);
        this.buffers.dispose();
        this.buffers = null;
    }
}
//# sourceMappingURL=fittedBuffers.js.map